import { Checkbox as CheckboxComponent } from "@headlessui/react";

export default function Checkbox({
  checked,
  onChange,
  className = "",
  checkboxClassName = "",
  iconClassName = "",
}) {
  return (
    <div className={`flex ${className}`}>
      <CheckboxComponent
        checked={checked}
        onChange={onChange}
        className={`group size-4 rounded bg-white/10 p-1 ring-1 ring-[#121619aa] ring-inset data-[checked]:bg-[#2D224E] cursor-pointer !text-white ${checkboxClassName}`}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`hidden size-2 fill-black group-data-[checked]:block  ${iconClassName}`}
        >
          <path
            d="M5.94755 12.6117L1.78754 8.42773C1.53762 8.17637 1.53762 7.76881 1.78754 7.51742L2.69262 6.60712C2.94254 6.35573 3.34779 6.35573 3.59772 6.60712L6.4001 9.42558L12.4025 3.38872C12.6524 3.13735 13.0577 3.13735 13.3076 3.38872L14.2127 4.29902C14.4626 4.55038 14.4626 4.95794 14.2127 5.20933L6.85265 12.6117C6.6027 12.863 6.19747 12.863 5.94755 12.6117Z"
            fill="currentColor"
          />
        </svg>
      </CheckboxComponent>
    </div>
  );
}
